import { environment } from "@appEnv/environment"
import { OptionModel } from "projects/vss-ui/src/public-api"
import { PATH } from "../../enum/constants"
import { PARAMETER } from "../../enum/common.enum"
import moment, { Moment } from "moment"

// patch multiselect data
export function getCheckedItem(listData: any[], selectedItem: any) {
  if (Array.isArray(selectedItem) && selectedItem.length) {
    listData.forEach((item: any) => {
      item.itemChecked = selectedItem.includes(item.value)
      if (item.children && item.children.length > 0) {
        getCheckedItem(item.children, selectedItem)
      }
    })
  } else {
    listData.forEach((item: any) => {
      item.itemChecked = selectedItem === item.value
      if (item.children && item.children.length > 0) {
        getCheckedItem(item.children, selectedItem)
      }
    })
  }
}

export function getCheckedAllItem(listData: any[], selectedItem: any[]) {
  const sortedListData = getAllValue(listData)?.slice()?.sort()
  const sortedSelectedItem = selectedItem?.slice()?.sort()

  if (JSON.stringify(sortedListData) === JSON.stringify(sortedSelectedItem)) {
    return true
  }
  return false
}

export function getAllValue(options: OptionModel[], result: any = []) {
  options.forEach((item: any) => {
    result.push(item.value)
    if (item.children && item.children.length > 0) {
      getAllValue(item.children, result)
    }
  })
  return result
}

export function getTableIsoString(date: any[], index = 0): string | null {
  return date?.length ? new Date(date[index]).toISOString() : null
}

export function convertToRoman(num: number) {
  const romanNumeralMap = [
    { value: 1000, symbol: 'M' },
    { value: 900, symbol: 'CM' },
    { value: 500, symbol: 'D' },
    { value: 400, symbol: 'CD' },
    { value: 100, symbol: 'C' },
    { value: 90, symbol: 'XC' },
    { value: 50, symbol: 'L' },
    { value: 40, symbol: 'XL' },
    { value: 10, symbol: 'X' },
    { value: 9, symbol: 'IX' },
    { value: 5, symbol: 'V' },
    { value: 4, symbol: 'IV' },
    { value: 1, symbol: 'I' }
  ]

  let result = ''
  for (let i = 0; i < romanNumeralMap.length; i++) {
    while (num >= romanNumeralMap[i].value) {
      result += romanNumeralMap[i].symbol
      num -= romanNumeralMap[i].value
    }
  }
  return result
}

export function convertStringJSONToArray(data: any) {

  try {
    // Parse the JSON string into an array of objects
    if (typeof data === 'string') {
      return JSON.parse(data)
    } else if (Array.isArray(data)) {
      return data
    } else {
      return []
    }
  } catch (error) {

    return []
  }
}

// thuần danh sách string
export function convertStringJSONToArray2(data: any) {
  try {
    return JSON.parse(data.replace(/'/g, '"'))
  } catch (error) {
    return []
  }
}

export function getImgById(id: number) {
  return id ? (environment.apiUrl + PATH + `/files/${id}/public`) : null
}

// export function getDayNameVN(date: Moment | Date | string): string {
//   return moment(date).locale('vi').format('dddd').replace(/^./, c => c.toUpperCase()) // "Thứ hai", "Thứ ba", ...
// }

export function getDayNameVN(date: Moment | Date | string): string {
  const days = ['Chủ nhật', 'Thứ 2', 'Thứ 3', 'Thứ 4', 'Thứ 5', 'Thứ 6', 'Thứ 7']
  const day = moment(date).day() // 0: Chủ nhật, 1: Thứ 2, ..., 6: Thứ 7
  return days[day]
}

export function toNumber(value: any): number {
  const num = Number(value)
  return isNaN(num) ? 0 : num
}
